const id_whs_serialnumber = {
    "": "nomor seri",
}

export default id_whs_serialnumber;